import {GenesisModal} from 'extensions/g-modal';
import styles from './tooltip-modal.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

export class TooltipModal extends GenesisModal {

	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	constructor () {
		super();
	}

};

defineCustomElement('rb-tooltip-modal', TooltipModal);
